import { Component, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../../animations/form-error';
import { BasePageComponent } from '../../../../base-page';
import { ChampsFormulaire } from '../../../../../model/champs_formulaire/champs-formulaire.model';
import { Subject } from 'rxjs';
import { BaseService } from '../../../base/base.service';
import { ChampsFormulaireService } from '../../champs_formulaires/champs-formulaire.service';
import { MatDialogRef } from '@angular/material/dialog';
import { FormService } from '../../../../../shared/services/form.service';
import { ChampsFormulaireColumnName } from '../../champs_formulaires/champs-formulaire-column-name';
import { UntypedFormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../../interfaces/app-state';
import { HttpService } from '../../../../../services/http/http.service';
import { takeUntil } from 'rxjs/operators';
import { FormValidator } from '../../../../../model/champs_formulaire/form-validator.model';
import { ValidatorAffectedService } from '../validator-affected.service';

/**
 * Permet de gérer la suppression d'un country
 */
@Component({
  selector: 'app-validator-affected-delete',
  templateUrl: './validator-affected-delete.component.html',
  animations: [fadeIn]
})
export class ValidatorAffectedDeleteComponent extends BasePageComponent
  implements OnInit, OnDestroy {
  countrySelected: FormValidator;
  private subs$ = new Subject<void>();
  isDeleting = false;
  successDelete = false;
  serverHasError = false;
  hasDelete = false;

  constructor(
    private baseService: BaseService,
    private formulaireService: ValidatorAffectedService,
    private dialogRef: MatDialogRef<ValidatorAffectedDeleteComponent>,
    private formService: FormService,
    private columnName: ChampsFormulaireColumnName,
    private fb: UntypedFormBuilder,
    store: Store<IAppState>, httpSv: HttpService) {
    super(store, httpSv);
    console.log('## construct validator delete');
  }

  ngOnInit(): void {
    console.log('## init formulaire delete.');
    this.formulaireService.getObjetSelectObs()
      .pipe(takeUntil(this.subs$)).subscribe((res) => {
      console.log('## get formulaire selected');
      try {
        console.log('## data: ', res);
        this.countrySelected = res;
      } catch (e) {
        console.log('## error get formulaire delete: ' + e.message);
      }
      super.setLoaded();
    });
  }

  ngOnDestroy() {
    console.log('## destroy formulaire delete');
    this.formService.free(this.subs$);
    this.formulaireService.setObjetSelectObs(undefined);
  }

  closeModal() {
    console.log('## close delete formulaire');
    this.dialogRef.close();
  }

  delete() {
    console.log('## deleting formulaire');
    this.isDeleting = true;
    this.serverHasError = false;
    this.successDelete = false;
    this.formulaireService.delete(this.countrySelected.id,
      this.formulaireService.resourceUrl).subscribe(
      response => {
        console.log('## success delete country');
        this.serverHasError = false;
        this.successDelete = true;
        this.isDeleting = false;
        this.hasDelete = true;
        this.responseFromServer();
        this.formulaireService.getAllObjet();
      }, error => {
        console.log('## error delete country');
        this.serverHasError = true;
        this.successDelete = false;
        this.isDeleting = false;
        this.responseFromServer();
      });
  }

  private responseFromServer() {
    setTimeout(() => {
      this.isDeleting = false;
    }, 300);
  }
}
